import React, { Component, PureComponent, Fragment } from 'react'
import { Icon } from 'semantic-ui-react'

export default class InlineInput extends Component {
  state = {
    editing: false,
    editValue: '',
    forceValue: false,
  }

  startEditing = () => {
    let { value } = this.props
    this.setState(
      {
        editing: true,
        editValue: value,
      },
      () => {
        if (this._input) this._input.focus()
      }
    )
  }

  handleKeyDown = e => {
    if (e.key === 'Enter') this.handleSave()
  }

  handleSave = () => {
    let { editValue } = this.state
    let { onUpdate } = this.props

    this.setState(
      {
        editing: false,
        forceValue: editValue,
      },
      () => {
        setTimeout(() => this.setState({ forceValue: false }), 500)
      }
    )

    onUpdate(editValue)
  }

  render() {
    let { title = false, value = '', onUpdate } = this.props

    let { editing, editValue, forceValue } = this.state

    let classes = ['inline-input']
    if (title) classes.push('inline-input--title')

    return (
      <div className={classes.join(' ')}>
        {!editing ? (
          <div className="inline-input-preview">
            <div className="inline-input-preview-value">{forceValue || value}</div>
            <button className="inline-input-preview-edit" onClick={e => e.preventDefault() & this.startEditing()}>
              <Icon name="edit" />
            </button>
          </div>
        ) : (
          <div className="inline-input-input">
            <div className="inline-input-input-value">
              <input
                type="text"
                value={editValue}
                onKeyDown={this.handleKeyDown}
                onChange={e => this.setState({ editValue: e.target.value })}
                ref={el => (this._input = el)}
              />
            </div>
            <button className="inline-input-input-edit" onClick={e => e.preventDefault() & this.handleSave()}>
              <Icon name="save" />
            </button>
          </div>
        )}
      </div>
    )
  }
}
